import { browser } from '$app/environment';
import { addContentToHead } from '$lib/services/advertising/script';
import { handleVendorConsent } from '$lib/services/tracking/didomi/consent';
import { META_PIXEL_VENDOR_ID, NO_SCRIPT_CONTENT, SCRIPT_CONTENT, SCRIPT_ID } from '$lib/services/tracking/metaPixel/constant';
import { isNogarnish } from '$lib/utils/nogarnish';

function setupMetaPixel() {
	const script = document.createElement('script');
	const noscript = document.createElement('noscript');

	script.type = 'text/javascript';
	script.id = SCRIPT_ID;
	script.defer = true;
	script.text = SCRIPT_CONTENT;
	script.fetchPriority = 'low';

	noscript.innerHTML = NO_SCRIPT_CONTENT;

	addContentToHead(script);
	addContentToHead(noscript);
}

export function useMetaPixel() {
	if (!browser || isNogarnish()) {
		return;
	}

	handleVendorConsent(META_PIXEL_VENDOR_ID, setupMetaPixel);
}
